import { cn } from "@/lib/utils";
import React from "react";

type props = {
  header?: string | React.ReactNode;
  tableLines: React.ReactNode[];
  tableClassName?: string;
};

/**
 * Component to show table
 */
export default function Table({ header, tableLines, tableClassName }: props) {
  return (
    <>
      {header && <div className={"w-full"}>{header}</div>}
      <div className={cn("table", tableClassName)}>
        <>
          {tableLines &&
            tableLines
              .filter((l) => l !== null)
              .map((tableLine) => {
                return tableLine;
              })}
        </>
      </div>
    </>
  );
}
